import { initAnalytics, trackPageview } from '@/adapters/observability/posthog.client'
import { createQueryClient } from '@/adapters/rpc/query-client'
import { applyTheme, readTheme } from '@/lib/theme'
import '@/styles/globals.css'
// After globals.css, so the project's accent wins (src/styles/brand.css).
import '@/styles/brand.css'
// Majik CRM's fonts — kept out of brand.css so `pnpm brand` never wipes them.
import '@/styles/brand-palette.css'
// Gideon's UX guide (docs/UX-GUIDE.md): type sizes and corners, over the template's.
import '@/styles/ux-guide.css'
import { QueryClientProvider } from '@tanstack/react-query'
import { createRouter, RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { routeTree } from './routeTree.gen.ts'
// The records a "Show me" tour step can name (docs/SYSTEM.md → Show me tours).
import './tour-placeholders.ts'

// Both resolve immediately when their key is absent, and never download.
void initAnalytics()
applyTheme(readTheme())

const queryClient = createQueryClient()

const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: 'intent',
  scrollRestoration: true,
})

// The router owns navigation events; PostHog's autocapture is off.
router.subscribe('onResolved', ({ toLocation }) => {
  trackPageview(toLocation.pathname)
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

const rootEl = document.getElementById('root')
if (!rootEl) throw new Error('No #root element in index.html')

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
)
